export const apiEndpoints = {
    loginUrl: `admin/auth/login`,
    signUrl: `admin/auth/signup`,
    forgetUrl: 'admin/auth/forgot_password',
    otpVerifyUrl: "admin/auth/verify_otp",
    resendOtpUrl: "admin/auth/resend_otp",
    changePasswordUrl: "admin/auth/change_password",
    resetPasswordUrl: "admin/auth/reset_password",
    profileUrl: "admin/auth/details",
    commonContentUrl: "common/common_content",
    commonContentUpdateUrl: "admin/common/common_content",
    userGetUrl: "admin/user/list",
    userDetailsUrl: "admin/user/details",
    userStatusUrl: "admin/user/status",
    userDashboardUrl: "admin/user/dashboard",
    hcGetUrl: "Hc/listing",
    hcDetailsUrl: "Hc/detail",
    hcAddDetailsUrl: "Hc/add_hc_details",
    hcUpdateDetailsUrl: "Hc/update_hc_details",
    getCompanyUrl: "company/listing",
    getCompanyDetailUrl: "company/detail",
    addCompanyUrl: "company/add_company_details",
    addDetailCompanyUrl: "company/add_employee_division",
    imageUploadUrl: "common/upload_file",
    happcoachGetUrl: "happcoach/listing",
    happcoachDetailsUrl: "happcoach/detail",
    happcoachAddDetailsUrl: "happcoach/add_happcoach_details",
    happcoachUpdateDetailsUrl: "happcoach/update_happcoach_details",
    cltGetUrl: "clt/listing",
    cltDetailsUrl: "happcoach/detail",
    cltAddDetailsUrl: "clt/add_clt_details",
    cltUpdateDetailsUrl: "clt/update_clt_details",
    updatePassword: "admin/auth/change_password",
    updateAdmin: "admin/auth/profile",
    getProfileData: "admin/auth/details",
    getDashboardUrl: "admin/auth/dashboard_count",
    getCompanyListing: "company/listing_admin",
    addCompanyDivision: "company/add_division_details",
    updateCompanyStatus: "company/update_company_details",
    getDeptListUrl: "department/listing_department_division",
    companyDetailsGraphActiveUSersUrl: "dashboard/company_active_employee_count",
    companyDetailsGraphDrActionUrl: "dashboard/dr_action_count",
    companygetEmpByType: "user/auth/listing_company_users",
    companygetEmpByEmpIdUrl: "user/auth/user_detail_by_id",
    divisionEmpTypeCount: "user/auth/count_company_users",
    resetHrcodeUrl: "company/hr_code_refresh",
    divisionDetailByIdUrl: "company/division_detail",
    settingsGetUrl: "common/setting_content",
    settingsUpdateUrl: "common/update_setting_content",
    getDashboardGraphUrl: "dashboard/compay_division_clt_happcoach_count",
    faqGetUrl: "common/questions",
    faqUpdateUrl: "common/add_question",
    messageGetUrl: "admin/user/clt_list_admin_chat",
    getUserDropdownById: "common/getUserDropdown",
    getCommonHCList: "Hc/hc_list_by_type",
    getActionCountAdmin: "Hc/action_count_users_admin",
    getActionCounHappCoach: "Hc/action_count_happcoach_users",
    AssignedMemberListing: "happcoach/happcoach_assign_user_list_admin_panel"
}